import { configureStore } from "@reduxjs/toolkit";


import authReducer from "./reducers/authReducer";
import globalReducer from "./reducers/globalReducer";
import userService from "./services/userService";
import customerService from "./services/customerService";
import settingsService from "./services/settingsService";
import dashboardService from "./services/dashboardService";
import { categoryService } from "./services/categoriesService";
import adService from "./services/adService";
import bookingsService from "./services/bookingService";
import notificationService from "./services/notificationService";




const Store = configureStore({
  reducer: {
    [userService.reducerPath]: userService.reducer,
    [customerService.reducerPath]: customerService.reducer,
    [settingsService.reducerPath]: settingsService.reducer,
    [dashboardService.reducerPath]: dashboardService.reducer,
    [categoryService.reducerPath]: categoryService.reducer,
    [adService.reducerPath]: adService.reducer,
    [bookingsService.reducerPath]: bookingsService.reducer,
    [notificationService.reducerPath]: notificationService.reducer,
    authReducer: authReducer,
    globalReducer: globalReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat([
    userService.middleware,
    customerService.middleware,
    settingsService.middleware,
    dashboardService.middleware,
    categoryService.middleware,
    adService.middleware,
    bookingsService.middleware,
    notificationService.middleware
  ]),
});

export default Store;
